import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsAreasIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('settings.areas.list');
  }
}

export default instrumentRoutePerformance(SettingsAreasIndexRoute);
